import React, { Component } from 'react';
import moment from "moment";
import MyInput from "../../../../components/shared/form/MyInput";
import MyCheckBox from '../../../../components/shared/form/MyCheckBox'
import MyTextArea from "../../../../components/shared/form/MyTextArea";
import MyDatePicker from "../../../../components/shared/form/MyDatePicker";
import MyTimePicker from "../../../../components/shared/form/MyTimePicker";
import camion from '../../../../media/icons/camion.svg'
import PieceOfInfo from "../../../shared/PieceOfInfo";

class FormLeaveIt extends Component {
  render() {
    const { info, infoPickUp, changeDate, changeHour, change, captureErrors } = this.props;
    return (
      <React.Fragment>
        <PieceOfInfo title="DEVOLUCIÓN"/>
        <div className="row mt-3">
          <div className="col-6">
            <MyDatePicker title="Fecha"
                          value={moment(info.date).toDate()}
                          onChange={changeDate}
                          name="timeToPickUp"
                          className="mr-md-2"/>
          </div>
          <div data-tip={true} data-for='changeDate' className="col-6">
            <MyTimePicker title="Hora"
                          value={moment(info.date).toDate()}
                          onChange={changeHour}
                          name="timeToPickUp"
                          className="ml-md-2"/>
          </div>
        </div>
        <div className="row form-check">
          <MyCheckBox title="Solicita servicio de recogida a domicilio" img={camion}
                      name="delivery" value={info.delivery}
                      onChange={change} className="mr-md-2"/>
        </div>
        {info.delivery &&
        <React.Fragment>
          <div className="row form-check">
            <MyCheckBox title="Recogida en el mismo lugar de entrega" name="samePlace" value={info.samePlace}
                        onChange={change} disabled={!infoPickUp.delivery} className="mr-md-2"/>
          </div>
          {!info.samePlace &&
          <React.Fragment>
            <div className="row">
              <div className="col-12">
                <MyInput title="Dirección" type="text" name="adress" value={info.adress}
                         onChange={change} captureErrors={captureErrors} notEmpty={info.delivery && !info.samePlace}/>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-4">
                <MyInput title="Ciudad" type="text" name="location" value={info.location}
                         onChange={change} captureErrors={captureErrors} notEmpty={info.delivery && !info.samePlace}
                         className="mr-md-2"/>
              </div>
              <div className="col-6 col-md-4">
                <MyInput title="CP" type="text" name="cp" value={info.cp}
                         onChange={change} captureErrors={captureErrors}
                         notEmpty={info.delivery && !info.samePlace}
                         className="mx-md-2"/>
              </div>
              <div className="col-6 col-md-4">
                <MyInput title="Teléfono" type="number" name="phone" value={info.phone}
                         onChange={change} captureErrors={captureErrors} minChar={9}
                         notEmpty={info.delivery && !info.samePlace}
                         className="ml-md-2"/>
              </div>
            </div>
          </React.Fragment>
          }
        </React.Fragment>
        }
        <div className="row">
          <div className="col-12">
            <MyTextArea title="Comentarios" name="comments" value={info.comments}
                        onChange={change} captureErrors={captureErrors}
                        placeholder={info.delivery ? "Si el lugar es un hotel, por favor indica su nombre" : ""}/>
          </div>
        </div>

      </React.Fragment>
    );
  }
}

export default FormLeaveIt;
